import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgLinkRightSquareOutline = function SvgLinkRightSquareOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2197 3.71967C16.5126 3.42678 16.9874 3.42678 17.2803 3.71967L20.7803 7.21967C21.0732 7.51256 21.0732 7.98744 20.7803 8.28033L17.2803 11.7803C16.9874 12.0732 16.5126 12.0732 16.2197 11.7803C15.9268 11.4874 15.9268 11.0126 16.2197 10.7197L18.4393 8.5H12.75C10.4028 8.5 8.5 10.4028 8.5 12.75V13.75C8.5 14.1642 8.16421 14.5 7.75 14.5C7.33579 14.5 7 14.1642 7 13.75V12.75C7 9.57437 9.57437 7 12.75 7H18.4393L16.2197 4.78033C15.9268 4.48744 15.9268 4.01256 16.2197 3.71967ZM2.75 7C3.16421 7 3.5 7.33579 3.5 7.75V17.25C3.5 17.9404 4.05964 18.5 4.75 18.5H19.25C19.6642 18.5 20 18.8358 20 19.25C20 19.6642 19.6642 20 19.25 20H4.75C3.23122 20 2 18.7688 2 17.25V7.75C2 7.33579 2.33579 7 2.75 7Z"
  })));
};

export { SvgLinkRightSquareOutline as ReactComponent };
//# sourceMappingURL=link-right-square-outline.svg.js.map
